import type { Middleware, MiddlewareAPI } from 'redux';
import { isAppWhitelisted } from '@makemydeal/dr-sales-checkin-ui-utils';
import type { SocketEventPayload } from '@makemydeal/dr-shared-bff-types';
import { DealXgSocketActions } from '../socket/dealXgSocketActionTypes';
import { showDealRefreshModal } from './dealRefreshActionCreators';
import { isDealRefreshModalVisible } from './selector';
import { DealXgTopic } from '@makemydeal/dr-shared-types/constants/dealXgTopics';

export const dealRefreshMiddleware = (config: {
    getAppNameWhitelist?: (state: any) => string[];
    /**
     * Host-supplied policy gate, evaluated per socket event. Injected rather than read
     * here so this middleware stays unaware of *why* refresh may be off — the
     * sales-checkin shell wires the F303238 edition capability, another host could wire
     * a toggle. Omitted means always enabled, preserving pre-gate behaviour.
     */
    isEnabled?: (state: any) => boolean;
    onRefresh: (store: MiddlewareAPI, meta?: Record<string, any>) => void;
}): Middleware => {
    const { getAppNameWhitelist = () => [], isEnabled = () => true, onRefresh } = config;

    return (store) => (next) => (action: { type: string; payload?: SocketEventPayload; meta?: Record<string, any> }) => {
        next(action);

        switch (action.type) {
            case DealXgSocketActions.SOCKET_EVENT_RECEIVED: {
                const state = store.getState();
                if (isDealRefreshModalVisible(state) || !isEnabled(state)) {
                    break;
                }
                if (action.payload?.topic !== DealXgTopic.DEAL_XG_CREATE) {
                    break;
                }
                const whitelist = getAppNameWhitelist(state);
                if (isAppWhitelisted(action.payload, whitelist)) {
                    store.dispatch(showDealRefreshModal());
                }
                break;
            }
            case DealXgSocketActions.REFRESH_DEAL_REQUESTED: {
                onRefresh(store, action.meta);
                break;
            }
        }
    };
};
